import React from 'react';
import CalculusOfCuriosity from '../components/CalculusOfCuriosity';

function CalculusOfCuriosityPage() {
  return <CalculusOfCuriosity />;
}

export default CalculusOfCuriosityPage;
